export default "__VITE_ASSET__Dr43$6bu__"